import { render, staticRenderFns } from "./CompanySwitcher.vue?vue&type=template&id=16b8f2d0&scoped=true"
import script from "./CompanySwitcher.vue?vue&type=script&lang=js"
export * from "./CompanySwitcher.vue?vue&type=script&lang=js"
import style0 from "./CompanySwitcher.vue?vue&type=style&index=0&id=16b8f2d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b8f2d0",
  null
  
)

export default component.exports